// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OrcamentosServicos_RemoveorcamentoservicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /orcamentos_servicos/removeOrcamentoServico
 *
 * Removes an orcamento_servico via the servicos_handler interactor.
 *
 * Data shape: boolean true on success
 *
 * @see Orcamentos_servicos::removeOrcamentoServico()
 * @see Atendente_interactor::RemoveServicoOrcamento()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type OrcamentosServicos_RemoveorcamentoservicoResponseDados = boolean;

export type OrcamentosServicos_RemoveorcamentoservicoResponse = ApiResponse<OrcamentosServicos_RemoveorcamentoservicoResponseDados>;

registerResponseContract('OrcamentosServicos_RemoveorcamentoservicoResponse', {})
